export const serverSide = false;
export const edgeRuntime = typeof (globalThis === null || globalThis === void 0 ? void 0 : globalThis.EdgeRuntime) === 'string';